import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';

// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
// import { StatusBar } from '@ionic-native/status-bar/ngx';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, EnvironmentProviders, NgModule, Provider, Type, provideAppInitializer } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { LeafletMarkerClusterModule } from '@bluehalo/ngx-leaflet-markercluster';

import { FullCalendarModule } from '@fullcalendar/angular';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { ToastrModule } from 'ngx-toastr';
import { SwiperModule } from 'swiper/angular';
// @scripts
import { AppRoutingModule } from './app-routing.module';

// @components
import { AppComponent } from './app.component';
import { WorkOrderBackModalComponent } from './components/work-order-back-modal/work-order-back-modal';
import { CalendarModalPageModule } from './pages/calendar-modal/calendar-modal.module';
import { CalendarModalPage } from './pages/calendar-modal/calendar-modal.page';
import { TimeScheduledPage } from './pages/time-sheduled/time-scheduled-page.component';
import { ApiRequestInterceptor } from './services/api/requests/apiRequestInterceptor.service';
import { EntityIndexesInitialized } from './services/database/dao/EntityIndexesInitialized';
import { LoggedUser } from './services/datamodel/LoggedUser';
import { LPRActivity } from './services/datamodel/LPRActivity';
import { LPRObservation } from './services/datamodel/LPRObservation';
import { LPRRecommendation } from './services/datamodel/LPRRecommendation';
import { LPRSummary } from './services/datamodel/LPRSummary';
import { DefObjectClass } from './services/datamodel/referenceData/DefObjectClass';
import { InspectorTerritory } from './services/datamodel/referenceData/InspectorTerritory';
import { LPRCode } from './services/datamodel/referenceData/LPRCode';
import { ObjectClass } from './services/datamodel/referenceData/ObjectClass';
import { ValsObjectClass } from './services/datamodel/referenceData/ValsObjectClass';
import { WoCode } from './services/datamodel/referenceData/WoCode';
import { WoType } from './services/datamodel/referenceData/WoType';
import { WoObject } from './services/datamodel/WoObject'; // a plugin
import { WorkOrder } from './services/datamodel/WorkOrder';
import { WoSummary } from './services/datamodel/WoSummary';
import { SharedModule } from './shared.module';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateService} from '@ngx-translate/core';

// Allows using older angular dependencies
declare module '@angular/core' {
    interface ModuleWithProviders<T = any> {
        ngModule: Type<T>;
        // providers?: Provider[];
        providers?: (Provider | EnvironmentProviders)[];
    }
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({ declarations: [AppComponent],
    exports: [],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        LeafletMarkerClusterModule,
        LeafletModule,
        HammerModule,
        CalendarModalPageModule,
        CommonModule,
        SwiperModule,
        IonicModule.forRoot({ mode: 'md', innerHTMLTemplatesEnabled: true }),
        AppRoutingModule,
        SharedModule,
        BrowserAnimationsModule,
        FullCalendarModule,
        ToastrModule.forRoot(),
        ServiceWorkerModule.register('/service-worker.js', { enabled: true }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        })], providers: [
        // StatusBar,
        // SplashScreen,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: ApiRequestInterceptor, multi: true },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        provideAppInitializer(() => {
        const initializerFn = (() => () => EntityIndexesInitialized.initialize([
                LoggedUser,
                WoType,
                WoCode,
                InspectorTerritory,
                LPRCode,
                LPRRecommendation,
                LPRActivity,
                LPRObservation,
                LPRSummary,
                ValsObjectClass,
                DefObjectClass,
                ObjectClass,
                WoSummary,
                WorkOrder,
                WoObject,
            ]))();
        return initializerFn();
      }),
        WorkOrderBackModalComponent,
        TranslateService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {}
